/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Work_Order_Publish_FailedInputs */



/**
* | output |
* | --- |
* | "External Work Order Publish Failed. {message}" |
*
* @param {Work_Order_Publish_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_failed = /** @type {((inputs: Work_Order_Publish_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la publication de l’ordre de travail externe. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Veröffentlichung des externen Arbeitsauftrags fehlgeschlagen. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Pubblicazione ordine di lavoro esterno non riuscita. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось опубликовать внешний рабочий заказ. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la publicación de la orden de trabajo externa. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`外部工单发布失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`外部作業指示書の公開に失敗しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`बाह्य कार्य आदेश प्रकाशन विफल। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha na publicação da ordem de serviço externa. ${i?.message}`)
	return /** @type {LocalizedString} */ (`External Work Order Publish Failed. ${i?.message}`)
});